/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { AlertResponse, ListAlertResponsesData, ListAlertResponsesResponse } from '@/client';
import { mgmtPlaneAPIClient } from '@/client/mgmtPlane';
import { usePaginatedQuery } from '@/hooks/query/usePaginatedQuery';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export type UseAlertResponsesQueryParams = {
  alertId: string | undefined;
  params?: Omit<ListAlertResponsesData, 'tenantId' | 'id'>;
  type?: 'inMemory' | 'queryParams';
};

export function useAlertResponsesQuery({ alertId, params, type }: UseAlertResponsesQueryParams) {
  const selectedTenantId = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  return usePaginatedQuery<ListAlertResponsesResponse, AlertResponse, unknown, unknown, ListAlertResponsesData>({
    apiCall: mgmtPlaneAPIClient.alerts.listAlertResponses.bind(mgmtPlaneAPIClient.alerts),
    filterTypes: {},
    queryKey: 'alertResponses',
    realtimeEvents: [],
    params: {
      tenantId: selectedTenantId!,
      id: alertId!,
      ...params,
    },
    type,
    enabled: !!selectedTenantId && !!alertId,
  });
}
